
import { Observable } from 'rxjs';
import { Globals } from 'src/app/shared/services/globals';
import { Component, ViewContainerRef, OnInit, AfterViewInit } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PermissionRoleService } from './account/services/permission-role.service';
import { Permission } from './shared/models/BasicData/Permission';
declare function  sideBar() : void;



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  title = 'das-app';
  isLoggedIn$: Observable<boolean>;
  options;
 element: HTMLElement;    
  constructor(public permissionMeni:PermissionRoleService, public global: Globals, private router: Router, private toastr: ToastrService , public translate: TranslateService) {
    translate.addLangs(['en', 'AR']);
    translate.setDefaultLang('AR');
   
    this.global.userRTL('AR');


    this.router.events.subscribe(event => {
      global.Messages = null;

      if (event instanceof RouteConfigLoadStart) {

        this.global.spinner = true;
      } else if (event instanceof RouteConfigLoadEnd) {

        this.global.spinner = false;
      }
    });
    
  }

  ngAfterViewInit() {
  
/*     this.permissionMeni.GetMenuPermssions().toPromise().then(res=>
      {
this.global.permissionsMenu=((res as any).data) as Permission[];

      } */
    //)

  }
  filldata()
  {
    
  }





}
